import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default function (devId) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_DEV_SPECIFICATIONS',
    manual: true,
  });

  const manualRequest = function () {
    if (devId) {
      let url = `/api/devices/${devId}/params/specifications`;
      exec(url);
    }
  };

  useEffect(() => {
    manualRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [devId]);

  return [data || [], manualRequest];
}
